module.exports = __webpack_public_path__ + "img/30.c8f3b2fb.jpg";